import { Checkbox } from 'antd';
import CheckboxGroup from './CheckboxGroup'; // @ts-ignore

Checkbox.Group = CheckboxGroup;
export default Checkbox;